module.exports = require('react-router');
module.exports.routerRedux = require('react-router-redux');



//////////////////
// WEBPACK FOOTER
// ./node_modules/dva/router.js
// module id = 231
// module chunks = 0 1 2 3 4 5 6 7 8 9 10